import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { MdCheckCircle } from 'react-icons/md';

const PaiementSucces: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        backgroundImage: 'url(https://beta.visamonde.com/assets/mobile/fond.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          width: '100%',
          maxWidth: 500,
          bgcolor: 'rgba(255,255,255,0.95)',
          textAlign: 'center',
          borderRadius: 2,
        }}
      >
        <MdCheckCircle size={80} color="#4CAF50" />

        <Typography variant="h4" sx={{ mt: 2, mb: 1, fontWeight: 'bold', color: '#4CAF50' }}>
          Paiement effectue !
        </Typography>

        <Typography variant="body1" sx={{ mb: 3, color: '#666' }}>
          Merci pour votre paiement. Votre commande a bien ete enregistree.
        </Typography>

        <Typography variant="body2" sx={{ mb: 3, color: '#888' }}>
          Nos equipes vont prendre en charge votre dossier dans les meilleurs delais.
          Vous recevrez un email de confirmation avec les details de votre commande.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          size="large"
          fullWidth
          onClick={() => navigate('/retour', { state: { tabValue: 2 } })}
          sx={{ mt: 2 }}
        >
          Retour a mes demandes
        </Button>
      </Paper>
    </Box>
  );
};

export default PaiementSucces;
